import React from 'react'
import { Link } from 'react-router-dom'
import { Text } from '@shopify/polaris'

const SubscriptionTrialMessage = ({ t }) => {
	return (
		<Text>
			{t("home.overPlan")} (
			<Link className='Polaris-Link' to='/subscription'>
				{t("home.selectPlan")}
			</Link>
		){t("home.dot")}
		<br />
		{t("home.canCont")}
		{t("home.dot")}
		</Text>
	)
}

export default SubscriptionTrialMessage

